// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__38Z_V","row":"Node_row__jf2lA","label":"Node_label__3TSse","footer":"Node_footer__1Edfv"};